import React, { useState, useMemo, useCallback } from 'react';
import { Tabs, Tab } from '@mui/material';
import strings from '../../Globalization/index';
import util from '../../util/index';
import consts from '../../consts';

const PhaseTabs = ({ data, onChange, value }) => {
	const [hasAccess, tabs] = useMemo(() => {
		let hasAccessVal = true;
		let tabsArr = [];
		if (typeof data?.chartDetail === 'object') {
			const chartDetailEntries = Object.entries(data.chartDetail);
			for (let i = 0; i < chartDetailEntries.length; i++) {
				const [key, value] = chartDetailEntries[i];
				let propertyName = key.split('_')[0];
				if (propertyName === 'EQUIPMENTDETAIL') {
					continue;
				}
				if (typeof value === 'boolean') {
					continue;
				}
				let tabName = propertyName;
				hasAccessVal = true;
				switch (propertyName) {
					case 'ENDOCHECK':
					case 'ENDOCOMPLETIONCHECK':
					case 'ADDITIONALFLOWCHECK':
						tabName = 'PRESSURECHECK' + tabName;
						hasAccessVal = util.checkAccess('FlowCheckAccess');
						break;
					case 'PREWASH1':
					case 'PREWASH2':
					case 'PREWASH3':
					case 'Prewash4':
						hasAccessVal = util.checkAccess('PreWashAccess');
						break;
					case 'WASH1':
					case 'WASH2':
					case 'WASH3':
					case 'WASH4':
						hasAccessVal = util.checkAccess('WashAccess');
						break;
					case 'RINSE':
					case 'RINSE1':
					case 'RINSE2':
					case 'RINSE3':
					case 'RINSE4':
						hasAccessVal = util.checkAccess('RinseAccess');
						break;
					case 'CHEMDISINFECTION1':
					case 'CHEMDISINFECTION2':
					case 'CHEMDISINFECTION3':
					case 'CHEMDISINFECTION4':
						hasAccessVal = util.checkAccess('DisinfectionAccess');
						break;
					case 'FINALRINSE1':
					case 'FINALRINSE2':
					case 'FINALRINSE3':
					case 'FINALRINSE4':
						hasAccessVal = util.checkAccess('FinalRinseAccess');
						break;
					default:
						break
				}
				if (hasAccessVal) {
					if (key !== consts.CycleTabName.LeakTest && key !== consts.CycleTabName.THERMALDISINPASS) {
						tabsArr.push({ value: key, label: strings[tabName], title: strings[tabName] });
					}
				}
			}
		}
		return [hasAccessVal, tabsArr];
	}, [data?.chartDetail]);
	const [activeTab, setActiveTab] = useState(value || tabs[0]);
	const handleOnTabChange = useCallback(
		(e, newValue) => {
			setActiveTab(newValue);
			if (typeof onTabChange === 'function') {
				onChange(newValue);
			}
		},
		[onChange]
	);

	return (
		<Tabs value={activeTab} onChange={handleOnTabChange} aria-label="phase tabs">
			{tabs?.map((tab, index) => (
				<Tab wrapped {...tab} key={`phase-tab-${index}`} />
			))}
		</Tabs>
	);
};
export default PhaseTabs;
